import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from 'app/app.config';
import { LocalStorageService } from 'app/core/services/local-storage/local-storage.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'Teranet-BusinessReport',
  templateUrl: './business-report.component.html'
})
export class BusinessReportComponent implements OnInit {
  Hangfireurl: string;
  url: SafeResourceUrl;
  BusinessReportUrl: string;
  constructor(private cookieService: CookieService,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService) {

    this.BusinessReportUrl = ((AppConfig.settings != undefined) && AppConfig.settings) ? AppConfig.settings.settings.BusinessReport_Url : this.localStorageService.getItem('BusinessReport_Url');
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.BusinessReportUrl);
  }
  ngOnInit() {
  }
}
